import React from 'react'
import { useGetDisbursementFeesQuery } from '../../../../api-services/payments/paymentsApi'
import { Button, Grid, Typography } from '@mui/material'
import Refresh from '@mui/icons-material/Refresh'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import HomeIcon from '@mui/icons-material/Home'
import LoadingComponent from '../../../components/ui-widgets/LoadingComponent'
import ErrorComponent from '../../../components/ui-widgets/ErrorComponent'
import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'
import CreateDisbursementFeeComponent from '../../../components/disbursements/CreateDisbursementFeeComponent'
import { DataGrid, type GridColDef } from '@mui/x-data-grid'
import CurrencyCodeChip from '../../../components/chips/CurrencyCodeChip'
import { formatDateStringAsApiFormat } from '../../../../utility/formatters/DateFormatter'
import { useHistory } from 'react-router-dom'

const DisbursementFeesPage: React.FC = () => {
  const getDisbursementFees = useGetDisbursementFeesQuery({})
  const refreshDisbursementFees = getDisbursementFees.refetch
  const history = useHistory()

  const feesColumns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 35, editable: false },
    {
      field: 'payoutSchedule',
      headerName: 'Payout Schedule',
      flex: 40,
      editable: false
    },
    {
      field: 'amount',
      headerName: 'Amount',
      flex: 35,
      editable: false
    },
    {
      field: 'currencyCode',
      headerName: 'Currency',
      flex: 35,
      editable: false,
      renderCell: params => <CurrencyCodeChip code={params.row.currencyCode} name={`[${params.row.currencyCode}] ${params.row.currencyCode}`}/>
    },
    {
      field: 'validFrom',
      headerName: 'Valid From',
      flex: 50,
      editable: false,
      renderCell: params => formatDateStringAsApiFormat(params.row.validFrom)
    },
    { field: 'createdBy', headerName: 'Created By', flex: 50, editable: false }
  ]

  return (
    <>
      <Box sx={{ mb: 2, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <Typography variant={'h4'}>Disbursement Fees</Typography>
        <Button variant={'text'} type="button" onClick={() => { history.push('/app/finance-area') }}>
          <HomeIcon style={{ color: '#444' }} />
        </Button>
      </Box>

      <Paper>
        <Grid container justifyContent="right" sx={{ pr: 4, pt: 2 }}>
          <Grid item>
            <Button variant={'contained'} type="button" onClick={refreshDisbursementFees}>
              <Refresh/>
            </Button>
          </Grid>
        </Grid>

        <Box sx={{ p: 3 }}>
          { getDisbursementFees.isLoading && <LoadingComponent />}
          { getDisbursementFees.isError && <ErrorComponent message={RtkQueryHelper.mapResponseError(getDisbursementFees.error)} />}
          { getDisbursementFees.isSuccess &&
            <>
              <CreateDisbursementFeeComponent />
                <Box sx={{ mt: 2 }}><DataGrid getRowId={(row) => row.id} rows={getDisbursementFees.data} columns={feesColumns} autoHeight={true} pagination pageSize={5} rowsPerPageOptions={[5]}/>
                </Box>
            </>
          }
        </Box>
      </Paper>
    </>
  )
}

export default DisbursementFeesPage
